/* globals document */
import $ from "jquery";

let commentsOverlay;

const CLASS_COMMENTS_OVERLAY_ACTIVE = "c-comments-overlay--active";

$(() => {
  commentsOverlay = $(".c-comments-overlay");
});

export function closeCommentsOverlay() {
  commentsOverlay.removeClass(CLASS_COMMENTS_OVERLAY_ACTIVE);
}

export function openCommentsOverlay() {
  commentsOverlay.addClass(CLASS_COMMENTS_OVERLAY_ACTIVE);
  commentsOverlay.focus();
  commentsOverlay.find("iframe").css({
    height: "100%"
  });
}

export function bindCommentsOverlay() {
  $(document).on("keydown", e => {
    if (e.key === "Escape") {
      closeCommentsOverlay();
    }
  });

  $(document).on("mouseup touchend click", ".c-comments-overlay--active", event => {
    if (event.target.className !== "c-comments-overlay__content") {
      closeCommentsOverlay();
    }
  });

}



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/commentsOverlay.js